<div class="app-overview" [ngClass]="{'merchandise-padding': isMerchandiseFlow()}" [ngStyle]="{'background-color':settingsData?.merchandise_bg_main_color, 'color':settingsData?.merchandise_font_main_color}">

    <div class="row">
        <div class="col-lg-7 col-sm-12 col-md-12 col-xs-12">

            <div class="d-flex justify-content-between">
                <div *ngIf="productImgsLength>1" class="imagesec">

                    <div class="pr-5 mb-3 " *ngFor="let img of productImgs ;let i =index">
                        <img class="imagelefDiv pointer" (click)="changeImg(img)" src="{{ img }}" (error)="removeBrokenImg(img)">
                    </div>

                </div>
                <!--  -->
                <div *ngIf="productImgsLength>0" class="imagediv" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color}">
                    <!-- <div *ngIf="productImgsLength>0" class="imagediv"
                [ngStyle]="{'background-image': 'url(' + productImgs[0] + ')'}" > -->
                    <img [src]="mainImg" alt="" class="mainimg" (error)="removeBrokenImg(mainImg)">


                </div>

            </div>


            <div *ngIf="productImgsLength>1" class="d-md-none d-flex  mt-3 justify-content-center">

                <div class="w-18" *ngFor="let img of productImgs ;let i =index">
                    <img class="imageSmallDiv w-100" (click)="changeImg(img)" src="{{ img }}" (error)="removeBrokenImg(img)" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color}">
                </div>

            </div>
        </div>

        <div class="col-lg-5 col-sm-12 col-md-12 col-xs-12">
            <div class="mb-3"> <span class="d-inline-block back-class pointer" [ngStyle]="{'color':settingsData?.merchandise_font_main_color}" (click)="goBack()"><span><i
                class="fa fa-angle-left" aria-hidden="true"></i></span><span>Back</span></span>
            </div>

            <div *ngIf="brandName" [ngStyle]="{'color':settingsData?.merchandise_button_bg_primary_color}" class="brandName">{{brandName}} </div>
            <p class="product-heading mb-0 mt-2"  [ngStyle]="{'color':settingsData?.merchandise_font_main_color}" *ngIf="productName">{{productName}}
                <span class="hearticon" [ngStyle]="{'color':settingsData?.merchandise_font_main_color}">
                <div *ngIf="wishlist_status != '1'" >
                    <span class="text-normal">Add to Wishlist</span>
                    <i class="pointer fa fa-heart-o pl-10" [ngClass]="settingsData?.is_preview ? 'disable' : 'pointer'" (click)="settingsData?.is_preview ? '' : gotoWishList()"></i>
                </div>
                <div *ngIf="wishlist_status == '1'" >
                    <span class="text-normal">Remove from Wishlist</span>
                    <i class="fa fa-heart pointer pl-10" [ngStyle]="{'color':settingsData?.merchandise_button_bg_primary_color}" (click)="goOutWishList()"></i>
                </div>
                </span></p>
            <!-- <div class="description" *ngIf="productDescriptionShort">
                {{productDescriptionShort}}
            </div> -->
            <div class="darkText mt-2" [ngStyle]="{'color':settingsData?.merchandise_font_main_color}">
                <!-- <span><img style="height:20px" src="../assets/logo-icon.svg"></span> 0.0987<span class="lytText">($
                0.98)</span> -->
                <span>
                    <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                    <!-- <app-svg [icon]="'arevea-green-symbol'"></app-svg> -->
                </span> <span class="lytText">
                    {{ productPrice | currency:productCurrency }}
                </span>

            </div>
            <div class="underline mt-3"></div>
            <div class="mt-3 p-3 borderbox" *ngIf="productDescriptionTrunc" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color, 'color':settingsData?.merchandise_font_main_color}">
                <p class="blockHeading mb-0">Description</p>
                <p class="blockContent div-break mb-0" [innerHTML]="productDescriptionTrunc | nl2br | safe: 'html'"></p>
                <p class="readMoreText pt-2" [ngStyle]="{'color':settingsData?.merchandise_button_bg_primary_color}" *ngIf="isReadMore" (click)="readMoreLess('more')">
                    Read More +
                </p>

                <p class="readMoreText pt-2" [ngStyle]="{'color':settingsData?.merchandise_button_bg_primary_color}" *ngIf="isReadLess && !isReadMore" (click)="readMoreLess('less')">
                    Read Less -
                </p>
            </div>
            <div *ngIf="showTimer" class="darkBlock p-3 mt-3" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color,'color':settingsData?.merchandise_font_secondary_color}">

                <p class="blockHeading">{{saleText}}</p>
                <div class="row">
                    <div class="col-3">
                        <div class="clockBLock" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color,'color':settingsData?.merchandise_font_secondary_color}">
                            <div class="countHrs">
                                {{days}}
                            </div>
                            <div>Days</div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="clockBLock" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color,'color':settingsData?.merchandise_font_secondary_color}">
                            <div class="countHrs">
                                {{hours}}
                            </div>
                            <div>Hours
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="clockBLock" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color,'color':settingsData?.merchandise_font_secondary_color}">
                            <div class="countHrs">
                                {{minutes}}
                            </div>
                            <div>Minutes </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="clockBLock" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color,'color':settingsData?.merchandise_font_secondary_color}">
                            <div class="countHrs">
                                {{seconds}}
                            </div>
                            <div>Seconds
                            </div>
                        </div>
                    </div>

                </div>
                <p class="dateText pt-1">{{saleStartOrEndDate}}</p>

            </div>
            <div class="underline mt-3"></div>

            <div *ngIf="prodAttributes">
                <div class="mt-3 p-3 borderbox" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color}" *ngFor="let attr of prodAttributes ;let i =index">
                    <p class="blockHeading mb-2"> {{attr.attribute_name}}</p>
                    <div class="row pb-10 no-gutters">

                        <div class="col-3 pr-10" *ngFor="let attrVals of attr.attributesList ;let j =index">

                            <button class="colorButton mb-10"
                            [style.background-color]="attrVals?.is_selected ? settingsData?.merchandise_button_bg_primary_color : null"
                            [style.color]="attrVals?.is_selected ? settingsData?.merchandise_button_font_primary_color : settingsData?.merchandise_font_main_color"
                            (click)="selectAttributes(attrVals)">
                                {{attrVals.value}}
                            </button>

                        </div>
                    </div>
                </div>
            </div>
            <div>
                <p class="blockHeading mt-2">Quantity</p>
                <div class="row mb-1">
                    <button (click)="decrement()" mat-flat-button class="minusButton ml-3" [ngStyle]="{'background-color':settingsData?.merchandise_button_bg_secondary_color, 'color':settingsData?.merchandise_button_font_secondary_color}">
                        <i class="fa fa-minus" ></i>
                    </button>
                    <button mat-flat-button class="numberButton ml-3" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color, 'color':settingsData?.merchandise_font_primary_color}">
                        {{counter}}
                    </button>
                    <button (click)="increment()" mat-flat-button class="plusButton ml-3" [ngStyle]="{'background-color':settingsData?.merchandise_button_bg_primary_color, 'color':settingsData?.merchandise_button_font_primary_color}">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>


            </div>
            <div class="mt-30 mb-1"  *ngIf="!hideBtns">
                <button mat-flat-button class="buyNow" [ngClass]="settingsData?.is_preview ? 'disable' : 'pointer'" [ngStyle]="{'background-color':settingsData?.merchandise_button_bg_primary_color, 'color':settingsData?.merchandise_button_font_primary_color}" (click)="buyNow()"
                    [hidden]="(productInventry == 0 && prodLimitedInventry) || !isShippingAvl" [disabled]="settingsData?.is_preview">
                    BUY NOW </button>
                <button mat-flat-button class="addTocart secondary-button-color ml-3" [ngStyle]="{'background-color':settingsData?.merchandise_button_bg_secondary_color, 'color':settingsData?.merchandise_button_font_secondary_color}" (click)="addToCart()" [disabled]="settingsData?.is_preview || justAddedToCart" [ngClass]="settingsData?.is_preview ? 'disable' : 'pointer'"
                    *ngIf="isShippingAvl">
                    {{ justAddedToCart ? 'ADDED ✓' : 'ADD TO CART' }} </button>
                <button mat-stroked-button class="addTocart goToCart ml-3" [style.--go-cart-color]="settingsData?.merchandise_button_bg_secondary_color" (click)="goToCart()"
                    *ngIf="isGoToCartActive">
                    <i class="fa fa-shopping-cart mr-2" aria-hidden="true"></i>VIEW CART </button>
                <span class="text-danger fs-13" *ngIf="!isShippingAvl">
                    Shipping not available in your country
                </span>
                <button mat-flat-button class="buy-btn buyNow sold-out"
                    *ngIf="productInventry == 0 && prodLimitedInventry">
                    SOLD OUT
                </button>

            </div>
        </div>

    </div>
</div>